<template>
  <el-dialog title="取消预约原因" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="110px">
      <el-form-item label="取消原因:" prop="cancelReason" class="width100">
        <el-select v-model="form.cancelReason" placeholder="请选择" clearable size="small" @change="handleTechnical">
          <el-option v-for="(item,index) in options.reasonOptions" :key="index" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注:" prop="cancelRemark" class="width100">
        <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="form.cancelRemark">
        </el-input>
      </el-form-item>
      <el-form-item label="图片:" prop="cancelImageUrls" class="width100">
        <el-upload :action="uploadImgUrl" list-type="picture-card" :file-list="cancelImageUrls"
          :on-success="handleImgUpload1" :on-remove="handleRemove1">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import sysDataconstantApi from '@/api/config/sysDataconstant'
  import technicianServiceOrderApi from '@/api/technical/technicianServiceOrder'
  function initFormBean() {
    const formBean = {
      cancelReason: null,
      cancelRemark: null,
      cancelImageUrls: null
    }
    return formBean
  }
  export default {
    data() {
      return {
        uploadImgUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload', // 上传的图片服务器地址
        form: initFormBean(),
        formVisible: false,
        dialogImageUrl: '',
        dialogVisible: false,
        isLoading:false,
        options: {
          reasonOptions: []
        },
        cancelImageUrls: [],
        formRules: {
          cancelReason: [{
            required: true,
            message: '请选择取消原因',
            trigger: 'change'
          }],
        },
        id:null
      }
    },
    methods: {
      handleImgUpload1(response, file, fileList) {
        if (file && file.response) {
          this.cancelImageUrls.push({
            url: file.response.data
          })
        }
      },
      handleRemove1(file, fileList) {
        this.cancelImageUrls = fileList
      },
      resetForm() {
        this.form = initFormBean()
        this.cancelImageUrls=[]
      },
      handleUpdate({id}) {
        console.log('id: ',id);
        this.id=id
        this.resetForm()
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
          this.getConfig()
        })
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      // 获取系统配置
      getConfig() {
        sysDataconstantApi.fetchBatchCode({
          code: 'servicceOrderCancelReasons'
        }).then(({
          data
        }) => {
          this.options.reasonOptions = data.list[0].content.split(',')
          // console.log("配置: ", data);
        })
      },
      postCallback() {
        this.$message.success('操作成功')
        this.formVisible = false;
        this.$emit('created')
        this.isLoading=false
      },
      doCreate() {
        this.$refs["dataForm"].validate((valid) => {
          if (valid) {
            this.isLoading = true
            if(this.cancelImageUrls.length){
              this.form.cancelImageUrls=this.cancelImageUrls.map(i=>(i.url)).join(',')
            }
            let params={
              id:this.id,
              ...this.form
            }
            technicianServiceOrderApi.updateCancel(params).then((data) => {
              this.postCallback()
            }).catch(res=>{
                this.isLoading=false
              })
            console.log('this.form: ',this.form,this.cancelImageUrls);
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .el-select {
    width: 100%;
  }
</style>
